import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MobileClientList, MobileClientDelete, createMobileClient, getMobileClientDataByID, updateMobileClientStatus, editMobileClient } from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";

const namespace = "client";

//<------------------------------------Mobile Client Slice------------------------------------>

// Async thunk for fetching the client list
export const getMobileClientList = createAsyncThunk(
    `${namespace}/getMobileClientList`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await MobileClientList(query, page, limit, sortby, order);
            return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for delete client
export const deleteMobileClient = createAsyncThunk(
    `${namespace}/deleteMobileClient`,
    async ({ deleteID }, { rejectWithValue, dispatch }) => {
        try {
            const data = await MobileClientDelete(deleteID);
            console.log("getCount--> ", data);
            return data;
        } catch (error) {
            console.log("getCount error--->", error);
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for adding a client
export const addMobileClient = createAsyncThunk(
    `${namespace}/addMobileClient`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            // Build FormData
            const formData = new FormData();
            let encrypted = EncryptDecrypt.encryptdata(postData, secretKey);
            formData.append("payload", encrypted);

            // Append file
            if (postData.image) {
                formData.append("image", postData.image);
            }

            const data = await createMobileClient(formData);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for fetching staff data by ID
export const getMobileClientData = createAsyncThunk(
    `${namespace}/getMobileClientData`,
    async ({ id }, { rejectWithValue }) => {
        console.log(id, 'client_id');
        try {
            const data = await getMobileClientDataByID(id);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Update client Status
export const MobileClientStatus = createAsyncThunk(
    `${namespace}/MobileClientStatus`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await updateMobileClientStatus({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating client data
export const updateMobileClient = createAsyncThunk(
    `${namespace}/updateMobileClient`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            const formData = new FormData();

            // Encrypt only the text data
            const encrypted = EncryptDecrypt.encryptdata(postData, secretKey);
            formData.append("payload", encrypted);

            // Append image only if available
            if (postData.image) {
                formData.append("image", postData.image);
            }

            const data = await editMobileClient(formData, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


const mobileClientSlice = createSlice({
    name: namespace,
    initialState: {
        clientListData: [],
        clientListLoading: false,
        addClientLoading: false,
        addClientSuccess: false,
        clientError: null,
        addedClient: null,
        getAddedData: [],
        getClientAddedDataLoading: false,
        updateData: [],
        updateClientSuccess: false,
        deleteClientLoading: false,
        deleteClientSuccess: false,
        deleteClientError: false,
        deleteClientErrorMessage: "",
        clientStatusLoading: false,
        clientStatusSuccess: false,
        clientStatusError: false,
        clientStatusErrorMessage: "",
    },
    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle getMobileClientList
            .addCase(getMobileClientList.pending, (state) => {
                state.clientListLoading = true;
                state.addClientLoading = false;
                state.addClientSuccess = false;
                state.clientError = null;
                state.addedClient = null;
                state.getAddedData = [];
                state.updateData = [];
                state.updateClientSuccess = false;
                state.deleteClientLoading = false;
                state.deleteClientSuccess = false;
                state.deleteClientError = false;
                state.deleteClientErrorMessage = "";
                state.clientStatusLoading = false;
                state.clientStatusSuccess = false;
                state.clientStatusError = false;
                state.clientStatusErrorMessage = "";
            })
            .addCase(getMobileClientList.fulfilled, (state, action) => {
                const data = action.payload;
                state.clientListData = data;
                state.clientListLoading = false;
                state.clientError = ''
            })
            .addCase(getMobileClientList.rejected, (state, action) => {
                state.clientListLoading = false;
                // state.clientError = action?.payload?.data?.errors[0]?.message;
                state.clientError = action.payload.data.message;
            })

            // Update client status
            .addCase(MobileClientStatus.pending, state => {
                state.clientStatusLoading = true;
                state.clientStatusSuccess = false;
                state.clientStatusError = false;
                state.clientStatusErrorMessage = "";
                state.deleteClientLoading = false;
                state.deleteClientSuccess = false;
                state.deleteClientError = false;
                state.deleteClientErrorMessage = "";
            })
            .addCase(MobileClientStatus.fulfilled, (state, action) => {
                state.clientStatusSuccess = true;
                state.clientStatusLoading = false;
                state.clientError = ''
            })
            .addCase(MobileClientStatus.rejected, (state, action) => {
                state.clientStatusError = true;
                state.clientStatusLoading = false;
                // state.clientStatusErrorMessage = action.error.message;
            })

            // Handle delete client
            .addCase(deleteMobileClient.pending, state => {
                state.deleteClientLoading = true;
                state.deleteClientError = false;
                state.deleteClientSuccess = false;
                state.deleteClientErrorMessage = "";
                state.clientStatusLoading = false;
                state.clientStatusSuccess = false;
                state.clientStatusError = false;
                state.clientStatusErrorMessage = "";
            })
            .addCase(deleteMobileClient.fulfilled, (state, action) => {
                state.deleteClientSuccess = true;
                state.deleteClientLoading = false;
                state.clientError = ''
            })
            .addCase(deleteMobileClient.rejected, (state, action) => {
                state.deleteClientError = true;
                state.deleteClientLoading = false;
                state.deleteClientErrorMessage = action.payload.data.error;
            })

            // Handle addMobileClient
            .addCase(addMobileClient.pending, (state) => {
                state.addClientLoading = true;
                state.clientError = null;
                state.addedStaff = null;
                state.addClientSuccess = false;
            })
            .addCase(addMobileClient.fulfilled, (state, action) => {
                state.addClientLoading = false;
                state.addedStaff = action.payload;
                state.addClientSuccess = true;
                state.clientError = ''
            })
            .addCase(addMobileClient.rejected, (state, action) => {
                state.addClientLoading = false;
                // state.clientError = action.error.message;
                state.addClientSuccess = false;
                // state.clientError = action?.payload?.data?.errors[0]?.message;
                state.clientError = action.payload.data.error;
            })

            // Handle getMobileClientData by ID
            .addCase(getMobileClientData.pending, (state) => {
                state.getClientAddedDataLoading = true;
            })
            .addCase(getMobileClientData.fulfilled, (state, action) => {
                const data = JSON.parse(EncryptDecrypt.decryptdata(action.payload.data.datas, secretKey));
                console.log(data, "data==");

                state.getAddedData = data.response;
                state.clientError = '';
                state.getClientAddedDataLoading = false;
            })
            .addCase(getMobileClientData.rejected, (state, action) => {
                // state.clientError = action?.payload?.data?.errors[0]?.message;
                state.clientError = action.payload.data.message;
                state.getClientAddedDataLoading = false;
            })

            // Handle updateMobileClient
            .addCase(updateMobileClient.pending, (state) => {
                state.updateClientSuccess = false;
            })
            .addCase(updateMobileClient.fulfilled, (state, action) => {
                state.updateData = action.payload;
                state.updateClientSuccess = true;
                state.clientError = ''
            })
            .addCase(updateMobileClient.rejected, (state, action) => {
                state.updateClientSuccess = false;
                // state.clientError = action?.payload?.data?.errors[0]?.message;
                state.clientError = action.payload.data.message;
            })

        //<------------------------------------Mobile Client Slice------------------------------------>
    },
});

export const { resetSuccessFlag } = mobileClientSlice.actions;

export const clientSelector = (state) => state[namespace];

export default mobileClientSlice.reducer;
